define([
	"dojo/_base/declare",
	"./ReviewActualGap",
	"../SizeChart"
], function(declare,ReviewActualGap,SizeChart) {

	return declare(ReviewActualGap, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return difference between actual and revised value
			var	actual = this._getActual(ctx);
			if (actual == this.DEFAULT) {
				return actual;
			}

			var	revised = this._getReviewDimension(ctx).Revised;
			if (revised == this.DEFAULT) {
				if (SizeChart.bSuggestRevised) {
					revised = this._getTarget(ctx);
				} else {
					return revised;
				}
			}

			return this._gap(revised, actual);
		}
	});
});